/**
 * Takes a flat array of tickets and returns an object where eventIDs are the keys
 * and the values are tickets that are for that event.
 *
 * @param {Ticket[]} tickets
 *
 * @return {Object.<number, Ticket[]>}
 */
const organiseTicketsByEvent = (tickets) => {
    const ticketsByEvent = {};

    tickets.forEach((ticket) => {
        if (ticket.eventID) {
            if (!ticketsByEvent.hasOwnProperty(ticket.eventID)) {
                ticketsByEvent[ticket.eventID] = [];
            }

            ticketsByEvent[ticket.eventID].push(ticket);
        }
    });

    return ticketsByEvent;
};

module.exports = {
    organiseTicketsByEvent,
};
